export const paths = {
  home: '/',
  categories: '/categories',
  category: (slug) => `/categories/${slug}`,
  allProducts: '/categories/all',
  product: (slug) => `/products/${slug}`,
  cart: '/cart',
  auth: '/auth',
  checkout: '/checkout',
  checkoutSummary: '/checkout/summary',
  checkoutPay: '/checkout/pay',
  orderStatus: '/order-status',
  account: '/account',
  deleteAccount: '/delete-account',
  accountAddresses: '/account/addresses',
  accountOrder: (orderId) => `/account/orders/${encodeURIComponent(orderId)}`,
  location: '/location',
  coupon: '/coupon',
  stores: '/stores',
  knowYourChicken: '/know-your-chicken',
  blogs: '/blogs',
  blogPost: (urlId) => `/blogs/${urlId}`,
  contactUs: '/contactUs',
  termsAndConditions: '/termsAndConditions',
  privacyPolicy: '/privacyPolicy',
  refundPolicy: '/refundPolicy',
};
